var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.48613 7.9206C1.76926 8.70485 2.55291 9.15084 3.3743 9.13652C10.709 9.00878 18.1428 9.13948 25.7673 9.16036C26.5987 9.16264 27.3777 8.68784 27.6616 7.8932C27.9676 7.03689 28.161 6.1555 28.161 5.24946C28.161 4.30045 27.97 3.3693 27.6367 2.47571C27.3655 1.74907 26.6591 1.31126 25.8957 1.27524C22.2481 1.10315 18.5001 1 14.5805 1C10.6543 1 6.8324 1.09701 3.22653 1.27416C2.48405 1.31064 1.79314 1.7275 1.52456 2.43238C1.17941 3.33814 1 4.28589 1 5.24946C1 6.16556 1.17377 7.05532 1.48613 7.9206Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0548 15.6073H17.3227",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8045 8.65381C25.3477 11.3353 25.6799 14.2236 25.6799 17.1921C25.6799 19.5893 25.4392 21.9074 25.0798 24.1447C24.9277 25.0918 24.17 25.8135 23.2322 25.9194C20.3237 26.2473 17.3128 26.4636 14.1887 26.4636C11.0928 26.4636 8.08625 26.12 5.21362 25.8648C4.24382 25.7786 3.4319 25.0613 3.27113 24.0849C2.90539 21.8641 2.69751 19.5687 2.69751 17.1921C2.69751 14.2236 3.00017 11.324 3.57294 8.65381",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.7ad6a54d59f7cfe6b58ba7129300e776.svg";
export { ForwardRef as ReactComponent };